import React from 'react';
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import BottomNav from '../../components/BottomNav';
import HeaderWithBack from '../../components/HeaderWithBack';
import Loading from '../../components/Loading';
import { useEprescriptions } from '../../hooks/useEprescriptions';
import { useAuthStore } from '../../stores/authStores';

const EprescriptionList: React.FC = () => {
  const navigate = useNavigate(); 
  const userData = useAuthStore((state) => state.user);
  const token = useAuthStore((state) => state.token);
  const { data: prescriptions = [], isLoading } = useEprescriptions(userData?.id,token);

  const getPrescriptionStatus = (status: string) => {
    switch (status) {
      case 'REDEEMED':
        return { label: 'Ditebus Online', className: 'bg-green-100 text-green-700' };
      case 'DOWNLOADED':
        return { label: 'Tidak Ditebus / PDF Diunduh', className: 'bg-gray-100 text-gray-700' };
      case 'EXPIRED':
        return { label: 'Kadaluarsa', className: 'bg-red-100 text-red-700' };
      default:
        return { label: 'Belum Ditebus', className: 'bg-yellow-100 text-yellow-800' };
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <HeaderWithBack title="E-Prescription" url="/home"/>

      {/* Profile Box */}
      <div className="bg-white p-4">
        <div className="bg-gray-100 rounded-md p-3 flex items-center justify-between shadow-sm">
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-gray-300 mr-3" />
            <span className="font-medium"> {userData ? userData?.person?.name : ""} <span className="text-sm text-gray-500">(Me)</span></span>
          </div>
        </div>
      </div>

      {/* List of Prescriptions */}
      {isLoading ? 
      <div className="flex-1 flex items-center justify-center">
        <Loading />
      </div>
      :
      <div className="px-4 pb-20">
        {prescriptions.length === 0 ? (
          <div className="text-center text-gray-500 mt-10">
            Tidak ada resep
          </div>
        ) : (
          prescriptions.map((item: any, index: number) => {
            const status = getPrescriptionStatus(item.prescription_status);

            return (
            <div key={index} className="mb-4">
              <div className="bg-teal-500 text-white px-3 py-1 rounded-t-md text-sm font-medium">
                {item.date}
              </div>
              <div className="border rounded-b-md p-4 shadow-sm">
                <div className="flex items-start justify-between gap-2">
                  <p className="font-semibold">Resep : {item.code}</p>
                  <span className={`shrink-0 rounded-full px-2 py-1 text-xs font-medium ${status.className}`}>
                    {status.label}
                  </span>
                </div>
                <p>{item.doctor}</p>
                <p className="text-sm text-gray-500">{item.specialty}</p>
                <div className="text-sm mt-2 mb-3 border-l-2 border-gray-300 pl-3">
                  Obat: {item.items.length} Item<br />
                  Batas Penebusan: {item.expired}
                </div>
                <button
                  className="bg-teal-500 text-white flex items-center px-4 py-1 rounded-md text-sm hover:bg-teal-600"
                  onClick={() => navigate(`/e-prescription/${item.id}`)}
                >
                  <FaEye className="mr-2" /> Lihat Resep
                </button>
              </div>
            </div>
            );
          })
        )}
      </div>
      }

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default EprescriptionList;
